import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-sm-12 col-md-6 offset-md-3" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mt-0" }
const _hoisted_6 = { class: "m-0 text-capitalize-first" }
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = { class: "d-block text-capitalize-first" }
const _hoisted_9 = {
  class: "d-flex gap-3",
  style: {"flex-wrap":"wrap","column-gap":"1rem !important","row-gap":"0.2rem !important"}
}
const _hoisted_10 = { class: "ms-1" }
const _hoisted_11 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = { class: "small" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = {
  key: 1,
  class: "row"
}
const _hoisted_18 = { class: "col-sm-12 col-md-6 offset-md-3" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-sm-12" }
const _hoisted_21 = { class: "card card-body mt-0" }
const _hoisted_22 = { class: "m-0 text-capitalize-first" }
const _hoisted_23 = { class: "mt-2" }
const _hoisted_24 = { class: "d-block text-capitalize-first" }
const _hoisted_25 = {
  class: "d-flex gap-3",
  style: {"flex-wrap":"wrap","column-gap":"1rem !important","row-gap":"0.2rem !important"}
}
const _hoisted_26 = { class: "m-0 text-capitalize-first" }
const _hoisted_27 = { class: "me-1" }
const _hoisted_28 = {
  id: "accounts",
  class: "row"
}
const _hoisted_29 = { class: "col-sm-12 col-md-6 offset-md-3" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-sm-12" }
const _hoisted_32 = {
  class: "d-flex justify-content-center align-items-center flex-wrap",
  style: {"column-gap":"1em"}
}
const _hoisted_33 = { class: "d-flex justify-content-between gap-3 flex-wrap" }
const _hoisted_34 = { class: "d-flex gap-2 align-items-center pe-1 ps-1" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 0,
  class: "row"
}
const _hoisted_38 = { class: "card card-body mt-0 col-sm-12" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = {
  key: 0,
  class: "col-sm-12 col-md-4 d-flex justify-content-center align-items-center pt-2 pb-2"
}
const _hoisted_41 = ["src"]
const _hoisted_42 = ["src"]
const _hoisted_43 = {
  key: 1,
  class: "col-sm-12 col-md-4 d-flex justify-content-center align-items-center pt-2 pb-2"
}
const _hoisted_44 = ["href"]
const _hoisted_45 = {
  key: 2,
  class: "col-sm-12 col-md-4 d-flex justify-content-center align-items-center pt-2 pb-2"
}
const _hoisted_46 = ["href"]
const _hoisted_47 = {
  key: 1,
  class: "row"
}
const _hoisted_48 = { class: "card card-body mt-0 col-sm-12" }
const _hoisted_49 = { class: "table align-middle text-left text-nowrap position-relative" }
const _hoisted_50 = { class: "" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "text-end" }
const _hoisted_53 = {
  key: 2,
  class: "row"
}
const _hoisted_54 = { class: "col-sm-12 col-md-6 offset-md-3" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-sm-12" }
const _hoisted_57 = { class: "card card-body mt-0" }
const _hoisted_58 = { class: "m-0 text-capitalize-first" }
const _hoisted_59 = { class: "mt-2" }
const _hoisted_60 = {
  key: 3,
  id: "stores",
  class: "row"
}
const _hoisted_61 = { class: "col-sm-12" }
const _hoisted_62 = { class: "ms-3 me-3 mb-0 text-center mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountWidget = _resolveComponent("AccountWidget")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_progress_bar = _resolveComponent("b-progress-bar")!
  const _component_b_progress = _resolveComponent("b-progress")!
  const _component_ReferralMerchantFeesTable = _resolveComponent("ReferralMerchantFeesTable")!
  const _component_MerchantStoresList = _resolveComponent("MerchantStoresList")!
  const _component_WithdrawalForm = _resolveComponent("WithdrawalForm")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_AccountWalletModal = _resolveComponent("AccountWalletModal")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "dashboardLoader",
    class: "h-100 p-2 pt-3"
  }, {
    default: _withCtx(() => [
      (_ctx.isTrader && !_ctx.user.pcId || _ctx.isTraderOperator)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_6, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.helper.trans("dashboard.trade_reward")), 1)
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList({'in':_ctx.payInRewardFee, 'out': _ctx.payOutRewardFee}, (rewardSettings, direction) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.helper.trans(`direction.${direction}`)), 1),
                        _createElementVNode("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rewardSettings, (settings) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "m-0 text-capitalize-first",
                              key: settings.name
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", null, _toDisplayString(settings.name) + ":", 1),
                                _createElementVNode("strong", _hoisted_10, [
                                  _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(settings.reward), 1)) + "% ", 1),
                                  (settings.additional)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: _normalizeClass(parseFloat(settings.additional) > 0 ? 'text-success' : '')
                                      }, _toDisplayString(parseFloat(settings.additional) > 0 ? '+' : '') + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(settings.additional), 1)) + "%", 3))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (settings.traderFeeByDealAmount && settings.traderFeeByDealAmount.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createElementVNode("small", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.fee_ranges')) + ":", 1),
                                    _createElementVNode("div", _hoisted_13, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(settings.traderFeeByDealAmount, (range, index) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: index,
                                          class: "me-2"
                                        }, [
                                          (range.minSum && range.maxSum)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(range.minSum.toString()) / 100, 2)) + " - " + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(range.maxSum.toString()) / 100, 2)) + " " + _toDisplayString(range.currency) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(range.fee), 1)) + "% ", 1))
                                            : (range.minSum)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, " ≥" + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(range.minSum.toString()) / 100, 2)) + " " + _toDisplayString(range.currency) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(range.fee), 1)) + "% ", 1))
                                              : (range.maxSum)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, " ≤" + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(range.maxSum.toString()) / 100, 2)) + " " + _toDisplayString(range.currency) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(range.fee), 1)) + "% ", 1))
                                                : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]))
                    }), 256))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.currencyRatesByGroups.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_22, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.helper.trans("labels.currency_rates")), 1)
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList({'in':_ctx.currencyRatesByGroups.filter(item =>item.direction === 'in'), 'out': _ctx.currencyRatesByGroups.filter(item =>item.direction === 'out')}, (currencyRates, direction) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.helper.trans(`direction.${direction}`)), 1),
                        _createElementVNode("div", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currencyRates, (settings) => {
                            return (_openBlock(), _createElementBlock("span", _hoisted_26, [
                              _createElementVNode("span", _hoisted_27, _toDisplayString(settings.name) + ":", 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(settings.currencyRates, (item, index) => {
                                return (_openBlock(), _createElementBlock("strong", {
                                  class: "me-2",
                                  key: index
                                }, _toDisplayString(_ctx.numberFormatter.formatMoney(item.rate)), 1))
                              }), 128))
                            ]))
                          }), 256))
                        ])
                      ]))
                    }), 256))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (account) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: account.currency,
                    class: "card card-body mt-0 w-100"
                  }, [
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_AccountWidget, {
                        "show-icon": true,
                        account: account
                      }, null, 8, ["account"]),
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_router_link, {
                          class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize",
                          "active-class": '',
                          "exact-active-class": '',
                          to: {name: 'accountOperations', query: {currency: account.currency}}
                        }, {
                          default: _withCtx(() => [
                            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fa fa-list" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("button.history")), 1)
                          ]),
                          _: 2,
                          __: [4]
                        }, 1032, ["to"]),
                        (_ctx.isTrader || _ctx.isTeamLead || _ctx.isReferral)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              onClick: _withModifiers(($event: any) => (_ctx.withdrawAccount = account), ["prevent"]),
                              class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                            }, [
                              _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa-solid fa-upload" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("button.withdraw")), 1)
                            ], 8, _hoisted_35))
                          : _createCommentVNode("", true),
                        (_ctx.isTrader || _ctx.isTraderOperator || _ctx.isTeamLead || _ctx.isReferral)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: _withModifiers(($event: any) => (_ctx.accountWalletModal?.show(account)), ["prevent"]),
                              type: "button",
                              class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                            }, [
                              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fa-solid fa-download" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("button.deposit")), 1)
                            ], 8, _hoisted_36))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          ((_ctx.isTrader || _ctx.isTraderOperator) && (_ctx.usdtRate || _ctx.bankAppsLink || _ctx.manualLink))
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    (_ctx.usdtRate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _createElementVNode("img", {
                            src: require(`@/assets/img/currencies/USDT.svg`),
                            style: {"height":"1.25rem"}
                          }, null, 8, _hoisted_41),
                          _createElementVNode("img", {
                            src: require(`@/assets/img/currencies/RUB.svg`),
                            style: {"height":"1.25rem","margin-left":"-7px"},
                            class: "me-1"
                          }, null, 8, _hoisted_42),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.usdtRate)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.bankAppsLink)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fa fa-mobile-screen-button me-2" }, null, -1)),
                          _createElementVNode("a", {
                            href: _ctx.bankAppsLink,
                            class: "float-end",
                            target: "_blank"
                          }, _toDisplayString(_ctx.helper.trans('labels.bank_apps_link')), 9, _hoisted_44)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.manualLink)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fa fa-external-link me-2" }, null, -1)),
                          _createElementVNode("a", {
                            href: _ctx.manualLink,
                            class: "float-end",
                            target: "_blank"
                          }, _toDisplayString(_ctx.helper.trans('labels.manual_link')), 9, _hoisted_46)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          ((_ctx.isTrader || _ctx.isTraderOperator) && _ctx.onlineAmountsStats.options && _ctx.onlineAmountsStats.options?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("table", _hoisted_49, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_50, [
                        _cache[9] || (_cache[9] = _createElementVNode("th", {
                          class: "text-capitalize",
                          style: {"width":"0"}
                        }, "Сумма", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlineAmountsStats.options, (option) => {
                          return (_openBlock(), _createElementBlock("th", {
                            style: _normalizeStyle({'width': (100 / _ctx.onlineAmountsStats.options.length) + '%'}),
                            key: option,
                            class: "text-capitalize"
                          }, [
                            option
                              ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.helper.trans(`payment_options.${option}`)), 1))
                              : _createCommentVNode("", true)
                          ], 4))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlineAmountsStats.stat, (stat, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.numberFormatter.formatNumber(stat.min)) + " - " + _toDisplayString(_ctx.numberFormatter.formatNumber(stat.max)), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlineAmountsStats.options, (option) => {
                            return (_openBlock(), _createElementBlock("td", { key: option }, [
                              _createVNode(_component_b_progress, {
                                max: "100",
                                class: "position-relative stat-progress-bar"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_b_progress_bar, {
                                    value: parseInt(stat.stats[option]?.percent),
                                    style: _normalizeStyle({background: _ctx.getProgressBackground(stat.stats[option]?.percent)}),
                                    class: ""
                                  }, null, 8, ["value", "style"]),
                                  _cache[10] || (_cache[10] = _createElementVNode("small", { class: "justify-content-center d-flex position-absolute w-100" }, null, -1))
                                ]),
                                _: 2,
                                __: [10]
                              }, 1024)
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.isReferral && _ctx.store.getters.getAppData?.REFERRAL_MERCHANT_FEES_ENABLED)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_58, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.helper.trans("dashboard.referral_merchant_fees")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_component_ReferralMerchantFeesTable)
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isMerchant || _ctx.isMerchantOperator)
        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("h5", _hoisted_62, _toDisplayString(_ctx.helper.trans("labels.stores")) + ":", 1)
            ]),
            _createVNode(_component_MerchantStoresList, {
              stores: _ctx.stores,
              merchant: _ctx.user,
              onUpdated: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadStores()))
            }, null, 8, ["stores", "merchant"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createVNode(_component_b_modal, {
          title: _ctx.helper.trans('labels.withdrawal'),
          modelValue: _ctx.withdrawAccount !== null,
          "header-class": "text-capitalize",
          "body-class": "pt-0",
          "footer-class": "d-flex justify-content-between",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($event === false && (_ctx.withdrawAccount = null)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_WithdrawalForm, {
              ref: "withdrawalForm",
              account: _ctx.withdrawAccount
            }, null, 8, ["account"])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.withdrawAccount = null)),
              class: "btn btn-outline-dark btn-sm text-capitalize-first"
            }, _toDisplayString(_ctx.helper.trans("button.cancel")), 1),
            _createVNode(_component_LoaderWrapper, {
              ref: "loaderWithdrawalForm",
              zoom: 0.5
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createWithdraw())),
                  class: "btn btn-outline-primary btn-sm text-capitalize-first"
                }, _toDisplayString(_ctx.helper.trans("button.withdraw")), 1)
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }, 8, ["title", "modelValue"]),
        _createVNode(_component_AccountWalletModal, { ref: "accountWalletModal" }, null, 512),
        _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512)
      ])
    ]),
    _: 1
  }, 512))
}